import entryMixin from '../../assets/mixins/entry';
import langs from '../../assets/locale/lang/check-in';
import { BEFORE_DESTROY } from '@/assets/utils/compat';

export default {
  langs,

  mixins: [entryMixin],

  props: {
    checkInSdk: {
      type: Object,
      default: null,
    },
    // 提示语的自定义 classname
    tipsClass: {
      type: String,
      default: '',
    },
    mountNode: {
      type: String
    },
  },

  data() {
    return {
      // 签到剩余时长
      leftTime: null,
      // 签到提示消息
      message: '',
      // 是否本次签到已点击提交
      disabled: false,
      socketConnected: true,
      // 是否强制签到
      forceCheckInEnabled: false,

      isShowList: false,
      isShowResult: true,
      list: [],
      oldCheckInSocket: false
    };
  },

  computed: {
    btnStyle() {
      return {
        backgroundImage: 'linear-gradient(90deg, #FFC038 0%, #FFA311 100%)',
        borderRadius: '25px',
        padding: 0,
        height: '100%'
      };
    }
  },

  watch: {
    checkInSdk: {
      immediate: true,
      handler() {
        this.bindAppEvents();
      },
    },
    isShowList: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$emit('update-modal-title', this.iarTrans('checkIn.record'));
        } else {
          this.$emit('update-modal-title', this.iarTrans('checkIn.signIn'));
        }
      }
    }
  },

  [BEFORE_DESTROY]() {
    this.unbindAppEvents();
  },

  methods: {
    _getCoreSdk() {
      return this.checkInSdk;
    },
    bindAppEvents() {
      const checkInSdk = this.checkInSdk;
      if (!checkInSdk) { return; }
      checkInSdk.bindSocketIOEvents();
      checkInSdk.on(checkInSdk.events.ON_SLICE_ID, this.onSliceIdHandler);
      checkInSdk.on(checkInSdk.events.SIGN_IN, this.onSignIn);
      checkInSdk.on(checkInSdk.events.STOP_SIGN_IN, this.onStopSignIn);
      checkInSdk.on(checkInSdk.events.SIGN_IN_TIME_UPDATED, this.onTimeUpdate);
      checkInSdk.on(checkInSdk.events.SIGN_IN_SUCCESS, this.onCheckInSuccess);
      checkInSdk.on(checkInSdk.events.SIGN_IN_FAIL, this.onCheckInFail);
      checkInSdk.on(checkInSdk.events.SIGN_IN_FINISH, this.onStopSignIn);
      checkInSdk.on(checkInSdk.socketIOEvents.DISCONNECT, () => {
        this.socketConnected = false;
      })
        .on(checkInSdk.socketIOEvents.CONNECT, () => {
          this.socketConnected = true;
          this.disabled = false;
        });
    },

    unbindAppEvents() {
      const checkInSdk = this.checkInSdk;
      if (!checkInSdk) { return; }
      checkInSdk.off(checkInSdk.events.SIGN_IN, this.onSignIn);
      checkInSdk.off(checkInSdk.events.STOP_SIGN_IN, this.onStopSignIn);
      checkInSdk.off(checkInSdk.events.SIGN_IN_TIME_UPDATED, this.onTimeUpdate);
      checkInSdk.off(checkInSdk.events.SIGN_IN_SUCCESS, this.onCheckInSuccess);
      checkInSdk.off(checkInSdk.events.SIGN_IN_FINISH, this.onStopSignIn);
    },

    onSliceIdHandler(msg) {
      if (msg.inSignIn) {
        this.showEntrance(true);
      }
    },

    // 处理开始签到消息
    onSignIn(msg) {
      this.isShowResult = false;
      if (msg.data.soundEnabled !== 'N') {
        this.playSoundEffects();
      }
      this.message = msg.data.message;
      this.isShowList = false;
      this.forceCheckInEnabled = this.checkInSdk.getForceCheckInEnabled();
      this.$emit('to-show');
      this.showEntrance(true);
    },

    // 处理结束签到消息
    onStopSignIn() {
      if (!(this.isShowResult || this.isShowList)) {
        this.$emit('to-hide');
      }
      if (this.forceCheckInEnabled) {
        this.emitCheckInStatus();
      }
      this.clear();
    },

    // 结束签到时回调用户签到状态
    async emitCheckInStatus() {
      const userCheckedIn = await this.checkInSdk.isUserCheckedIn();
      this.$emit('check-in-status', userCheckedIn);
    },

    // 点击签到
    signIn() {
      // 防重复点击
      if (this.disabled) { return; }
      // TODO 防 js 脚本模拟点击
      // const signBtn = e.target;
      // const signBtnRange = {
      //   x1: signBtn.getBoundingClientRect().left,
      //   x2: signBtn.getBoundingClientRect().left + signBtn.clientWidth,
      //   y1: signBtn.getBoundingClientRect().top,
      //   y2: signBtn.getBoundingClientRect().top + signBtn.clientHeight,
      // };
      // const inXRange = e.clientX >= signBtnRange.x1 && e.clientX <= signBtnRange.x2;
      // const inYRange = e.clientY >= signBtnRange.y1 && e.clientY <= signBtnRange.y2;
      // if (
      //   e.pageX === null ||
      //   e.pageY === null ||
      //   !inXRange ||
      //   !inYRange
      // ) {
      //   return;
      // }
      this.disabled = true;
      this.checkInSdk.toCheckIn();
    },

    // 清除数据
    clear() {
      this.message = '';
      this.leftTime = null;
      this.disabled = false;
    },

    // 签到剩余时长更新
    onTimeUpdate({ totalMsecs }) {
      // 毫秒转秒
      this.leftTime = Math.ceil(totalMsecs / 1000);
    },

    // 签到成功
    onCheckInSuccess() {
      // this.$emit('to-hide');
      // this.showSubmitTips({
      //   tipsClass: this.tipsClass,
      //   mountNode: this.mountNode
      // });
      // 恢复下次签到可点击
      this.isShowResult = true;
      this.$nextTick(() => {
        this.clear();
      });
    },
    onCheckInFail() {
      this.$emit('to-hide');
      this.showSubmitTips({
        tips: this.iarTrans('checkIn.submitEndFail'),
        duration: 2000,
        submitStatus: 'fail',
        mountNode: this.mountNode
      });

      if (this.forceCheckInEnabled) {
        this.emitCheckInStatus();
      }

      // 恢复下次签到可点击
      this.$nextTick(() => {
        this.clear();
      });
    },
    async getCheckInInfo() {
      try {
        const res = await this.checkInSdk.getCheckInInfo();
        // 返回码为201时，展示签到页
        if (res.code === 201) {
          this.isShowList = false;
          this.showEntrance(true);
        } else if (res.code === 200) {
          // 返回码为20时，展示签到列表
          this.showList();
          this.list = res.data;
          if (this.list.length > 0) {
            this.showEntrance(true);
          }
        }
        return Promise.resolve(res);
      } catch (e) {
        this.isShowList = false;
        this.oldCheckInSocket = true;
        throw new Error(e);
      }

    },
    showEntrance(val) {
      this.$emit('show-entrance', val);
    },
    showList() {
      this.isShowList = true;
      this.isShowResult = false;
    },
  },
};
